import { APIPaths } from "@/apis/api-config";
import BaseApi from "@/apis/base-api";

export class TaskTplApi extends BaseApi {
  async getTaskTplList(
    queryParameters: APIPaths["/admin-dash/task-tpl/list"]["get"]["parameters"]["query"],
  ): Promise<APIPaths["/admin-dash/task-tpl/list"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get("/admin-dash/task-tpl/list", { params: queryParameters })).data;
  }

  async postTaskTplNew(
    requestBody: APIPaths["/admin-dash/task-tpl/new"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/admin-dash/task-tpl/new"]["post"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.post("/admin-dash/task-tpl/new", requestBody)).data;
  }

  async getTaskTplById(
    pathParameters: APIPaths["/admin-dash/task-tpl/{id}"]["get"]["parameters"]["path"],
  ): Promise<APIPaths["/admin-dash/task-tpl/{id}"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get(`/admin-dash/task-tpl/${pathParameters.id}`)).data;
  }

  async patchTaskTplById(
    pathParameters: APIPaths["/admin-dash/task-tpl/{id}"]["patch"]["parameters"]["path"],
    requestBody: APIPaths["/admin-dash/task-tpl/{id}"]["patch"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/admin-dash/task-tpl/{id}"]["patch"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.patch(`/admin-dash/task-tpl/${pathParameters.id}`, requestBody)).data;
  }

  async deleteTaskTplById(
    pathParameters: APIPaths["/admin-dash/task-tpl/{id}"]["delete"]["parameters"]["path"],
  ): Promise<APIPaths["/admin-dash/task-tpl/{id}"]["delete"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.delete(`/admin-dash/task-tpl/${pathParameters.id}`)).data;
  }
}
